export var DEPLOY_DATE = new Date('2025-12-04T13:57:59+0000');
